import {useSearchOptions} from "../../../hooks/useSearchOptions";
import {alertListURL, sensorAlertListURL} from "./alertTable.constants";

export const useAlertSearchOptions = (alertType = "system") => {
  const url = alertType === "system" ? alertListURL : sensorAlertListURL;
  const options = useSearchOptions(url, [
    "name",
    "inventory__name",
    "sites__name",
    "locations__name",
  ]);

  const searchOptions = [
    {
      category: {label: "Name", value: "name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.name,
    },
    {
      category: {label: "Site", value: "inventory__location__site__name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options["sites__name"],
    },
    {
      category: {label: "Location", value: "inventory__location__name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options["locations__name"],
    },
    {
      category: {label: "Appliance", value: "inventory__name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options["inventory__name"],
    },
  ];
  return {searchOptions};
};
